import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataRefreshService {
  // boolean-based refresh (used globally)
  private refreshSubject = new BehaviorSubject<boolean>(false);
  refreshNeeded$ = this.refreshSubject.asObservable();

  triggerRefresh() {
    this.refreshSubject.next(true);
  }

   // string-based refresh (used for specific events)
   private typedRefreshSubject = new Subject<string>();
   typedRefresh$ = this.typedRefreshSubject.asObservable();
   
  // method to trigger refresh by type
  triggerTypedRefresh(type: string): void {
    this.typedRefreshSubject.next(type);
  }
}
